import { createContext, useMemo } from 'react';

import { Project, Repository } from 'src/components/types';

import { useFetchStarredItemsForWorkspace } from './hooks';
import type { StarredObjectType } from './hooks';

type StarredItemsContextType = {
  starredRepositories: Repository[];
  starredProjects: Project[];
  isLoading: boolean;
  isStarred: (
    objectType: StarredObjectType,
    resource: Repository | Project
  ) => boolean;
  setStarred: (
    objectType: StarredObjectType,
    resource: Repository | Project,
    isStarred: boolean
  ) => void;
};

export const StarredItemsContext = createContext<
  StarredItemsContextType | undefined
>(undefined);

type StarredItemsProviderProps = {
  children: React.ReactNode;
};

export const StarredItemsProvider = ({
  children,
}: StarredItemsProviderProps) => {
  const starredItems = useFetchStarredItemsForWorkspace();

  const value = useMemo<StarredItemsContextType>(
    () => ({
      starredRepositories: starredItems.starredRepositories,
      starredProjects: starredItems.starredProjects,
      isLoading: starredItems.isLoading,
      isStarred: starredItems.isStarred,
      setStarred: starredItems.setStarred,
    }),
    [
      starredItems.starredRepositories,
      starredItems.starredProjects,
      starredItems.isLoading,
      starredItems.setStarred,
      starredItems.isStarred,
    ]
  );

  return (
    <StarredItemsContext.Provider value={value}>
      {children}
    </StarredItemsContext.Provider>
  );
};
